import React, { useEffect, useRef, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { TextField } from "@material-ui/core";

const CustomPaperSizeDialog = ({ open, badgeSize, onClose, onContinue }) => {
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [errors, setErrors] = useState({ width: '', height: '' });

  useEffect(() => {
    if (open) {
      setWidth('');
      setHeight('');
      setErrors({ width: '', height: '' })
    }
  }, [open]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Reset errors
    setErrors({ width: '', height: '' });

    let hasErrors = false;
    const newErrors = { width: '', height: '' };

    // Validate width
    const widthNum = parseFloat(width);
    if (!width || isNaN(widthNum)) {
      newErrors.width = 'Please enter a valid number';
      hasErrors = true;
    } else if (widthNum < badgeSize.widthInMm) {
      newErrors.width = `A paper width must not be smaller then the choosen badge width (${badgeSize.widthInMm} mm)`;
      hasErrors = true;
    }

    // Validate height
    const heightNum = parseFloat(height);
    if (!height || isNaN(heightNum)) {
      newErrors.height = 'Please enter a valid number';
      hasErrors = true;
    } else if (heightNum < badgeSize.heightInMm) {
      newErrors.height = `A paper height must not be smaller then the choosen badge height (${badgeSize.heightInMm} mm)`;
      hasErrors = true;
    }

    if (hasErrors) {
      setErrors(newErrors);
      return;
    }

    onContinue({
      width: widthNum,
      height: heightNum,
    });
    onClose();
  };


  const inputRef = useRef(null);

  const handleEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };


  return (
    <Dialog
      open={open}
      TransitionProps={{
        onEntered: handleEntered,
      }}
      onClose={onClose}
      disableEnforceFocus
    >
      <DialogContent>
        <h3 className="dialog-title">Enter paper dimensions in mm</h3>
        <div className="print-dialog-content">
          <TextField
            inputRef={inputRef}
            autoFocus
            margin="dense"
            label="Width (mm)"
            type="number"
            fullWidth
            value={width}
            onChange={(e) => setWidth(e.target.value)}
            error={!!errors.width}
            helperText={errors.width}
            inputProps={{ step: "1" }}
          />
          <TextField
            margin="dense"
            label="Height (mm)"
            type="number"
            fullWidth
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            error={!!errors.height}
            helperText={errors.height}
            inputProps={{ step: "1" }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <button className="button" onClick={onClose}>
          Back
        </button>
        <button
          className="primary"
          onClick={handleSubmit}
        >
          Continue
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomPaperSizeDialog;
